import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 32px;
`;
export const Button = styled.button`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy1};
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
    text-underline-position: under;
  `}
`;
